export default __webpack_public_path__ + "static/media/header-4.a582bd79.jpg";